export default __webpack_public_path__ + "static/media/screen3.b568ed9d.png";